<template>
  <v-container fluid>
    <div id="content">

      <section class="d-flex">
        <BreadCrumb :items="$route.matched"></BreadCrumb>
      </section>

    </div>
  </v-container>
</template>

<script>

export default {
  data() {
    return {
      
    }
  },
  prop: {},
  mounted() {
    
  },
  beforeDestroy() {},
  created() {
    if (!this.isAllowed(this.$route.name)) this.$router.push('/')
  },
  computed: {
    
  },
  watch: {
    
  },
  methods: {
    //初期化
    async init() {

    },
  },
}
</script>

<style lang='scss' scoped>

</style>
